<template>
  <div>
    <my-preview ref="preview"></my-preview>
    <el-input readonly v-model="myValue">
      <template slot="append">
        <el-button @click="$refs.preview.show(myValue)" size="small" type="primary" icon="el-icon-view"></el-button>
        <el-upload style="display:inline-block;width:10px;margin-left:28px" :accept="accept" :show-file-list="false"
          :action="$axios.defaults.baseURL + '/Api/Upload'" :on-success="upload" :headers="headers">
          <el-button size="small" type="primary" icon="el-icon-upload" :disabled="disabled" class="btn"></el-button>
        </el-upload>
      </template>
    </el-input>
  </div>
</template>
<script>
export default {
  props: {
    value: {},
    accept: {},
    disabled: { default: false },
  },
  data() {
    return {
      myValue: this.value,
      headers: { token: localStorage.getItem("token") },
    };
  },

  mounted() {
    if (this.accept === "image") this.accept = "image/jpg,image/jpeg,image/png";
    if (this.accept === "audio") this.accept = "audio/map3";
  },

  watch: {
    //监听内容变化
    value(newValue) {
      this.myValue = newValue
    },
    myValue(newValue) {
      this.$emit('input', newValue)
    }
  },

  methods: {
    upload(res) {
      if (res.code === 200) {
        this.myValue = res.data;
        this.$forceUpdate();
        this.$message.success("上传成功。");
      } else this.$message.error(res.msg);
    },
  }
}
</script>
<style  scoped>
.btn{
  transform: translateY(-1px);
}
.btn.is-disabled:hover{
  background-color:#f5f7fa;
  border: #f5f7fa;
  color: #909399;
}
</style>